// Libraries
import React from 'react';
// Core
import {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import CoreStyles from '../core/Styles';
import {FixedSpace} from '../core/Spacing';
// Controls
import Button from '../controls/Button';
// Layouts
import ToolBar from '../layouts/ToolBar';

export default class ShareBar extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            toolbar: {
                paddingLeft: 0,
                paddingRight: 0,
            },
        });
        return (
            <ToolBar styles={[styles.toolbar, CoreStyles.hairlineStrokeTop]}>
                <Button title="Google Classroom" style={Button.Style.Text} />
                <FixedSpace />
                <Button title="Facebook" style={Button.Style.Text} />
                <FixedSpace />
                <Button title="Twitter" style={Button.Style.Text} />
                <FixedSpace />
                <Button title="Email" style={Button.Style.Text} />
            </ToolBar>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/ShareBar.jsx